//-- Copyright (c) 2021 TMT Insights Group, LLC
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import styled from '@emotion/styled';
import { ListItemText } from '@mui/material';
import { FileBrowserConfig } from "@/__configs/config_types";
import { useConfigValue } from "@/components/_hooks/useConfigValue";
import { isOverflown } from '@/_utils/utils';
import ConditionalTooltip from "@/components/_common/ConditionalTooltip/ConditionalTooltip";

interface FileItemTextProps {
  name: string | React.JSX.Element;
  onClick?: any;
}

const FileItemText = ({ name, onClick = null }: FileItemTextProps, ref: any) => {
  const renderFileName: FileBrowserConfig['renderFileName'] = useConfigValue(['fileBrowserConfig', 'renderFileName']);
  const nameRef = useRef();
  const [overflown, setOverflown] = useState(false);

  useEffect(() => {
    nameRef?.current && setOverflown(isOverflown(nameRef?.current));
  }, [name]);

  return (
    <StyledConditionalTooltip show={overflown} title={name} ref={ref}>
      {overflown && renderFileName ? renderFileName(name as string) : <StyledListItemText primary={name} disableTypography ref={nameRef} onClick={onClick} />}
    </StyledConditionalTooltip>
  );
};

export default forwardRef(FileItemText);

const StyledListItemText = styled(ListItemText)`
  white-space: nowrap;
  user-select: none;
  flex-grow: 0;
`;

const StyledConditionalTooltip = styled(ConditionalTooltip)`
  overflow: hidden;
  text-overflow: ellipsis;
`;
